// src/redux/reducers/contractorFormReducer.js

import {
  SET_CONTRACTOR_FORM_DATA,
  UPDATE_CONTRACTOR_FORM_DATA,
  CLEAR_CONTRACTOR_FORM_DATA,
} from "../actions";

// Define the initial state for contractor form data
const initialState = {
  formData: {},
  extractedData: {},
  isProcessing: false,
  errors: {},
};

// The contractorFormReducer handles contractor form data actions
const contractorFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTRACTOR_FORM_DATA:
      return {
        ...state,
        formData: action.payload,
        errors: {},
      };
    
    case UPDATE_CONTRACTOR_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.fieldName]: action.payload.value,
        },
        errors: {
          ...state.errors,
          [action.payload.fieldName]: null, // Clear error when field is updated
        },
      };
    
    case CLEAR_CONTRACTOR_FORM_DATA:
      return initialState;
    
    default:
      return state;
  }
};

export default contractorFormReducer; 